module.exports = "/static/assets/a89ad1d0754a6ca305a1011dad503c96.png";